var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalaryImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1929_24128",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.125,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1929_24128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.3788 8.37873C8.82833 8.37873 8.36243 8.18806 7.98109 7.80672C7.59975 7.42538 7.40909 6.95948 7.40909 6.40901C7.40909 5.85854 7.59975 5.39264 7.98109 5.0113C8.36243 4.62996 8.82833 4.4393 9.3788 4.4393C9.92927 4.4393 10.3952 4.62996 10.7765 5.0113C11.1578 5.39264 11.3485 5.85854 11.3485 6.40901C11.3485 6.95948 11.1578 7.42538 10.7765 7.80672C10.3952 8.18806 9.92927 8.37873 9.3788 8.37873ZM4.18171 10.8182C3.79013 10.8182 3.45488 10.6788 3.17597 10.3999C2.89706 10.1209 2.7576 9.78563 2.7576 9.39392V3.4241C2.7576 3.03252 2.89706 2.69728 3.17597 2.41837C3.45488 2.13946 3.79013 2 4.18171 2H14.5757C14.9674 2 15.3027 2.13946 15.5816 2.41837C15.8605 2.69728 16 3.03252 16 3.4241V9.39392C16 9.78563 15.8605 10.1209 15.5816 10.3999C15.3027 10.6788 14.9674 10.8182 14.5757 10.8182H4.18171ZM5.36354 9.63639H13.3941C13.3941 9.2435 13.5335 8.90786 13.8124 8.62947C14.0913 8.35122 14.4266 8.21209 14.8182 8.21209V4.60593C14.4253 4.60593 14.0897 4.46648 13.8114 4.18757C13.5332 3.90865 13.3941 3.57341 13.3941 3.18183H5.36354C5.36354 3.57472 5.22408 3.9103 4.94517 4.18855C4.66626 4.46681 4.33101 4.60593 3.93943 4.60593V8.21209C4.33232 8.21209 4.6679 8.35154 4.94615 8.63046C5.22441 8.90937 5.36354 9.24468 5.36354 9.63639ZM13.6515 13.5758H1.4243C1.03259 13.5758 0.697279 13.4364 0.418368 13.1575C0.139456 12.8785 0 12.5432 0 12.1515V4.34849H1.18183V12.1515C1.18183 12.2121 1.20704 12.2676 1.25747 12.3182C1.30802 12.3687 1.36363 12.394 1.4243 12.394H13.6515V13.5758ZM4.18171 9.63639H3.93943V3.18183H4.18171C4.11605 3.18183 4.05926 3.20579 4.01133 3.25372C3.9634 3.30165 3.93943 3.35845 3.93943 3.4241V9.39392C3.93943 9.45958 3.9634 9.51637 4.01133 9.5643C4.05926 9.61236 4.11605 9.63639 4.18171 9.63639Z",
    fill: "#038840"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalaryImg);
export default __webpack_public_path__ + "static/media/salary-img.de4573b2134ab6b7ed012cfe4c0bff6f.svg";
export { ForwardRef as ReactComponent };